<span 
  class="icon-wrapper" 
  [style.width.px]="size" 
  [style.height.px]="size" 
  [innerHTML]="svgIcon"
  role="img"
  aria-hidden="true">
</span>
